function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "ldio-qk859g4t8om-filter",
  x: "-100%",
  y: "-100%",
  width: "300%",
  height: "300%",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceGraphic",
  stdDeviation: 3
}), /*#__PURE__*/React.createElement("feComponentTransfer", {
  result: "cutoff"
}, /*#__PURE__*/React.createElement("feFuncA", {
  type: "linear",
  slope: 60,
  intercept: -40
}))));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#ldio-qk859g4t8om-filter)",
  transform: "rotate(211.1 50 50)"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  repeatCount: "indefinite",
  dur: "3.0303030303030303s",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(263.434 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 0,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.7666666666666666 0 0.6666666666666666 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(280.947 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 1,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.7333333333333333 0 0.6333333333333333 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(295.062 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.7 0 0.6 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(306.156 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 3,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.6666666666666666 0 0.5666666666666667 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(314.831 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 4,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.6333333333333333 0 0.5333333333333333 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(321.654 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 5,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.6 0 0.5 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(327.077 50.0001 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 6,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.5666666666666667 0 0.4666666666666667 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(331.442 50.0001 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 7,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.5333333333333333 0 0.43333333333333335 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(335 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 8,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.5 0 0.4 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(337.933 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 9,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.4666666666666667 0 0.36666666666666664 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(340.378 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 10,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.43333333333333335 0 0.3333333333333333 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(342.438 50.0001 50.0001)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 11,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.4 0 0.3 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(344.188 50.0001 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 12,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.3666666666666667 0 0.26666666666666666 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(345.688 50.0001 50.0001)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 13,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.33333333333333337 0 0.23333333333333334 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(346.984 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 14,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.30000000000000004 0 0.2 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(348.11 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 15,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.26666666666666666 0 0.16666666666666666 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(349.095 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 16,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.23333333333333334 0 0.13333333333333333 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(349.962 50.0002 50.0002)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 17,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.2 0 0.1 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(350.729 50 50)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 18,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.16666666666666669 0 0.06666666666666667 1",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(351.411 50.0001 50.0001)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(50 20)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 19,
  fill: "currentColor",
  transform: "scale(0.5)"
})), /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  calcMode: "spline",
  type: "rotate",
  values: "0 50 50;360 50 50",
  keyTimes: "0;1",
  dur: 1.0101010101010102,
  keySplines: "0.13333333333333333 0 0.03333333333333333 1",
  repeatCount: "indefinite"
})));

var SvgClockLoading = function SvgClockLoading(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      margin: "auto",
      background: "rgba(241, 242, 243, 0)",
      display: "block"
    },
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClockLoading, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-loading.50ce7271.svg";
export { ForwardRef as ReactComponent };